var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.441406 10.5391C0.441406 10.9375 0.59375 11.2773 0.910156 11.582L10.0508 20.5234C10.2969 20.7812 10.625 20.9102 11 20.9102C11.7617 20.9102 12.3594 20.3242 12.3594 19.5508C12.3594 19.1758 12.207 18.8359 11.9492 18.5781L3.71094 10.5391L11.9492 2.5C12.207 2.23047 12.3594 1.89062 12.3594 1.51562C12.3594 0.753906 11.7617 0.167969 11 0.167969C10.625 0.167969 10.2969 0.296875 10.0508 0.554688L0.910156 9.49609C0.59375 9.80078 0.453125 10.1406 0.441406 10.5391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.52116a9ff88d2190e92b2a142aeb3a9d.svg";
export { ForwardRef as ReactComponent };